import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const IdentityDetailsMalaysia = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { nationalIDNo, errors } = formState;

  const inputElements = [
    {
      belongsTo: ['Malaysia National ID', 'Malaysia Credit Bureau'],
      element: (
        <TextFieldGroup
          key="nationalIDNo"
          id="nationalIDNo"
          type="text"
          name="nationalIDNo"
          dataName="panMY"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.nationalIDNo')}
          value={nationalIDNo}
          placeholder={transUTL('translatePlaceholder.inputMY.nationalIDNo')}
          placeholderTrigger={isEmptyVAL(nationalIDNo) ? 'input-empty' : ''}
          error={errors.nationalIDNo}
          errorTrigger={errors.nationalIDNo ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

IdentityDetailsMalaysia.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default IdentityDetailsMalaysia;
